var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDivx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m139.832 0h192.729l147.381 147.352v327.693a37.085 37.085 0 0 1 -36.984 36.955h-303.126a37.084 37.084 0 0 1 -36.983-36.955v-438.09a37.065 37.065 0 0 1 36.983-36.955z",
    fill: "#dce3e9",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m156.649 349.465a7.2 7.2 0 0 1 0-14.4h269.493a7.2 7.2 0 0 1 0 14.4zm0 107.978a7.2 7.2 0 0 1 0-14.4h269.493a7.2 7.2 0 0 1 0 14.4zm0-54a7.2 7.2 0 1 1 0-14.4h269.493a7.2 7.2 0 0 1 0 14.4z",
    fill: "#44546c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m40.219 147.352h263.581a8.184 8.184 0 0 1 8.16 8.16v118.178a8.178 8.178 0 0 1 -8.16 8.132h-263.581a8.179 8.179 0 0 1 -8.161-8.132v-118.178a8.185 8.185 0 0 1 8.161-8.16z",
    fill: "#70c716",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m332.561 0 147.381 147.352h-126.8a20.61 20.61 0 0 1 -20.576-20.576z",
    fill: "#44546c",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m145.72 249.414a7.2 7.2 0 0 1 -14.4 0v-69.654a7.2 7.2 0 0 1 14.4 0zm139.54-3.993a7.174 7.174 0 0 1 -11.92 7.985l-17.311-25.906-17.312 25.909a7.173 7.173 0 0 1 -11.919-7.985l20.6-30.834-20.6-30.835a7.173 7.173 0 0 1 11.919-7.985l17.312 25.909 17.311-25.909a7.174 7.174 0 0 1 11.92 7.985l-20.6 30.835zm-129.86-63.359a7.179 7.179 0 0 1 13.61-4.576l16.5 49.283 16.466-49.283a7.179 7.179 0 0 1 13.61 4.576l-23.266 69.566a7.187 7.187 0 0 1 -13.639.059zm-90.666-9.5h23.252a30.547 30.547 0 0 1 30.484 30.484v23.083a30.547 30.547 0 0 1 -30.484 30.484h-23.257a7.2 7.2 0 0 1 -7.2-7.2v-69.653a7.2 7.2 0 0 1 7.2-7.2zm23.257 14.4h-16.064v55.257h16.059a16.12 16.12 0 0 0 16.087-16.087v-23.087a16.172 16.172 0 0 0 -16.087-16.087z",
    fill: "#eaf6ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivx);
export default __webpack_public_path__ + "static/media/divx.eeee73c1aa5b706ec4e746b80cc5e276.svg";
export { ForwardRef as ReactComponent };